import type { ReactNode } from 'react';

import styles from './SectionHeader.module.scss';

type SectionHeaderProps = {
  readonly title: ReactNode;
  readonly subtitle?: ReactNode;
  readonly actions?: ReactNode;
  readonly compact?: boolean;
  readonly className?: string;
};

export function SectionHeader({ title, subtitle, actions, compact, className }: SectionHeaderProps) {
  const classes = [styles.header, compact ? styles.compact : '', className ?? '']
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes}>
      <div className={styles.textBlock}>
        <h2 className={styles.title}>{title}</h2>
        {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
      </div>
      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </div>
  );
}
